/* Mobile sticky cart follows the actual Navi+ bottom menu, without overriding theme eligibility. */
(() => {
  const mobile = window.matchMedia('(max-width: 767px)');
  const root = document.documentElement;
  let frame = 0;
  let timer;

  function menuVisible() {
    const menu = document.querySelector('#SF-3536553765.mobile-bottom');
    if (!menu || !menu.getClientRects().length) return false;
    for (let node = menu; node; node = node.parentElement) {
      const style = getComputedStyle(node);
      if (node.hidden || style.display === 'none' || style.visibility === 'hidden' ||
          style.visibility === 'collapse' || Number(style.opacity) === 0) return false;
    }
    const rect = menu.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 &&
      rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
  }

  function update() {
    frame = 0;
    const visible = mobile.matches && menuVisible();
    if (root.classList.contains('dt-navi-bottom-visible') !== visible) {
      root.classList.toggle('dt-navi-bottom-visible', visible);
    }
    let suppressSticky = false;
    if (mobile.matches) {
      const productPage = document.querySelector('product-page.main-product');
      const productButton = productPage && productPage.querySelector('[data-js-product-add-to-cart]');
      if (productButton && productButton.getClientRects().length) {
        const rect = productButton.getBoundingClientRect();
        suppressSticky = rect.bottom > 0 && rect.top < window.innerHeight &&
          rect.right > 0 && rect.left < window.innerWidth;
      }
      const mainSection = productPage && productPage.closest('.shopify-section');
      if (mainSection) {
        let section = mainSection.nextElementSibling;
        while (section) {
          if (section.classList.contains('shopify-section') &&
              section.getClientRects().length && section.querySelector('.product-item')) {
            if (section.getBoundingClientRect().top <= window.innerHeight * 0.5) suppressSticky = true;
            break;
          }
          section = section.nextElementSibling;
        }
      }
    }
    if (root.classList.contains('dt-sticky-context-hidden') !== suppressSticky) {
      root.classList.toggle('dt-sticky-context-hidden', suppressSticky);
    }
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }

  const observer = new MutationObserver(schedule);
  function configure() {
    observer.disconnect();
    clearInterval(timer);
    if (mobile.matches) {
      observer.observe(document.body, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['class', 'style', 'hidden']
      });
      // Also catches CSS animations and visibility changes without DOM mutations.
      timer = setInterval(() => { if (!document.hidden) schedule(); }, 250);
    }
    update();
  }

  function start() {
    if (!document.querySelector('sticky-add-to-cart')) return;
    configure();
    mobile.addEventListener('change', configure);
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    document.addEventListener('visibilitychange', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
